import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, NgForm, ValidationErrors } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router"
import { NzMessageService } from 'ng-zorro-antd/message';
import { Observable, Observer } from 'rxjs';
import { ProgramaService } from '../../../services/programa.service';
import { AutorizadorService } from '../../../services/autorizador.service';

@Component({
    selector: 'app-lancamento-programa',
    templateUrl: './lancamento-programa.component.html',
    styleUrls: ['./lancamento-programa.component.css'],
    standalone: false
})
export class LancamentoProgramaComponent implements OnInit {
  programaForm!: UntypedFormGroup;
  idprograma = null;
  dataProgramaAtt = null;
  autorizadores: Array<{ label: string; value: string; }> = [];
  isVisibleCadAutorizador = false;
  constructor(
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private message: NzMessageService,
    private programaService: ProgramaService,
    private autorizadorService: AutorizadorService
  ) { 
    this.programaForm = this.newFormPrograma();

    this.route.params.subscribe(res => this.idprograma = res.idprograma);
  }

  ngOnInit(): void {
    if (this.idprograma !== undefined) {
      this.programaService.detalhar(this.idprograma).subscribe((p: any) => {
        let item = p.data.programa;
        this.dataProgramaAtt = item;
        this.programaForm.get('idprograma').setValue(item.idprograma);
        this.programaForm.get('idautorizador').setValue(item.idautorizador);
        this.programaForm.get('nome').setValue(item.nome);
      });
    } else {
      this.programaForm.reset();
    }
    this.getAutorizadores();
  }

  newFormPrograma() {
    return new UntypedFormGroup({
      idprograma: new UntypedFormControl(''),
      idautorizador: new UntypedFormControl('', [Validators.required]),
      nome: new UntypedFormControl('', [Validators.required]),
    });
  }

  onSubmitPrograma() {
    if (this.programaForm.valid) {
      let id = this.message.loading('Salvando cadastro...').messageId;
      if (this.idprograma !== undefined) {
        let dadosEdicao = this.programaForm.value;

        this.programaService.atualizar(dadosEdicao).subscribe((p: any) => {
          this.router.navigate(['/programa']);
          this.message.remove(id);
          this.message.success('O programa foi atualizado com SUCESSO!');
        });

      } else {
        this.programaService.criar(this.programaForm.value).subscribe((p: any) => {
          this.message.remove(id);
          this.router.navigate(['/programa']);
          this.message.success('O programa foi cadastrado com SUCESSO!');
        });
      }

    } else {
      for (const i in this.programaForm.controls) {
        this.programaForm.controls[i].markAsDirty();
        this.programaForm.controls[i].updateValueAndValidity();
      }
    }
  }

  getAutorizadores() {
    this.autorizadorService.all(1, '', 100).subscribe((u: any) => {
      u.data.autorizador.data.forEach(item => {
        if(item['ativo'] === 1){
          this.autorizadores.push({
            label: item['nome'],
            value: item['idautorizador']
          });
        }
        
      });
    });
  }

  openCadAutorizador(){
    this.isVisibleCadAutorizador = true;
  }

}
